<template>
  <v-layout
    class="patient-page"
    column
  >

        <!-- <v-layout
          row
          class="mt-4"
        >
          <v-text-field
            v-model="searchFields.patient.lastName"
            label="Patient Last Name"
            outline
            persistent-hint
            autofocus
            @keyup.enter="searchRequest"
            clearable
          >
          </v-text-field>
          <v-text-field
            class="ml-4"
            label="Patient First Name"
            v-model="searchFields.patient.firstName"
            outline
            @keyup.enter="searchRequest"
            clearable
          >
          </v-text-field>
        </v-layout> -->
        <v-data-table
          
          class="flat table-border"
          sort-icon=""
          color="#eeeeee"
          :headers="headers"
          :items="activeRequests"
          :pagination.sync="currentPagination"
          :rows-per-page-items="rowsPerPageItems"
          :total-items="requestsPageInfo.total"
          @update:pagination="updatePagination"
          :loading="loadingRequests"
        >
          <!-- :search="search" -->
          <template
            slot="items"
            slot-scope="props"
          >
            <tr
              style="cursor:pointer"
              v-if="props.item"
              @click="showMoreInfo(props.item)"
              :class="alternatingColors(props.index)"
            >
              <td class="text-xs-left pt-3 pb-3" valign="top"> {{ props.item.providerID }}</td>
              <td class="text-xs-left pt-3 pb-3" valign="top">{{ props.item.patientID }}</td>
              <td class="text-xs-left pt-3 pb-3" valign="top">{{ props.item.status }}</td>
              <td class="text-xs-left pt-3 pb-3" valign="top">{{props.item.createdDate}}</td>
              <td class="text-xs-left pt-3 pb-3" valign="top">{{ props.item.lastLog }}</td>
            </tr>
          </template>

          <template
            slot="expand"
            slot-scope="props"
          >
            <v-card flat>
              <v-card-text>{{ props.item }}</v-card-text>
            </v-card>
          </template>

        </v-data-table>

    <request-info-dialog ref="requestInfoDialog" />

  </v-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Titlebar from '@/components/Titlebar'
import RequestInfoDialog from '@/components/dialogs/RequestInfoDialog'
import HelperMixin from '@/core/mixins/HelperMixin'

export default {
  mixins: [HelperMixin],
  components: {
    Titlebar,
    RequestInfoDialog
  },
  data() {
    return {
      // Search fields
      searchText: null,
      searchFields: {
        patient: {
          firstName: '',
          lastName: ''
        },
        provider: {
          firstName: '',
          lastName: ''
        }
      },
      patientSearchArray: null,
      providerSearchArray: null,
      searchState: 0,

      headers: [
        {
          text: 'Provider',
          align: 'left',
          sortable: false,
          value: 'providerID'
        },
        {
          text: 'Patient',
          sortable: true,
          value: 'patientID',
          align: 'left'
        },
        { text: 'Status', sortable: true, value: 'status', align: 'left' },
        { text: 'Created', sortable: true, value: 'created', align: 'left' },
        {
          text: 'Last Note',
          sortable: true,
          value: 'note.message',
          align: 'left'
        }
      ],
      formattedRequests: null,

      // Pagination
      rowsPerPageItems: [25, 50, 100],
      currentPagination: {
        rowsPerPage: 25
      },
      lastOrder: false,
      lastSortBy: ''
    }
  },
  methods: {
    ...mapActions('admin', ['getRequests', 'getPatient', 'getPatients']),
    ...mapActions('provider', [
      'getInvidualProvider',
      'getProviderAuth',
      'search'
    ]),
    alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate'
      } else {
        return 'grayAlternate'
      }
    },
    filter(payload) {
      console.log('filtering')
      console.log(payload)
      return true
    },
    updatePagination(pag) {
      let requestOrder = ''
      if (this.lastOrder && pag.sortBy === this.lastSortBy) {
        requestOrder = '-' + pag.sortBy
        this.lastOrder = false
      } else {
        requestOrder = pag.sortBy
        this.lastOrder = true
      }
      this.lastSortBy = pag.sortBy

      let requestOptions = {
        limit: this.currentPagination.rowsPerPage,
        offset: (pag.page - 1) * pag.rowsPerPage,
        order: requestOrder
      }
      if (this.patientSearchArray) {
        requestOptions['patients'] = this.patientSearchArray
      }
      this.getRequests(requestOptions)
    },
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    convertDateToDaysInProgress(timestamp) {
      let d = new Date(timestamp * 1000)
      var oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      var firstDate = d
      var secondDate = new Date()

      var diffDays = Math.round(
        Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
      )

      return diffDays
    },
    formatProviderName(item) {
      return 'Provider Error'
    },
    formatProviderFax(item) {
      return 'Provider Error'
    },
    formatProviderPhone(item) {
      return 'provider phone'
    },
    formatPartnerName(item) {
      return 'error'
    },
    getLastNote(item) {
      if (item.log) {
        if (item.log.length > 0) {
          return item.log[0].message
        }
      }
      return ''
    },
    formatPatientName(item) {
      if (item.patient) {
        if (item.patient.firstName) {
          return (
            item.patient.firstName +
            ' ' +
            item.patient.lastName +
            ' DOB: ' +
            this.convertDate(item.patient.birthdate)
          )
        } else {
          return 'Missing Patient'
        }
      } else {
        return 'Missing patient'
      }
    },
    formatDate(timestamp) {
      if (timestamp != null) {
        let d = new Date(timestamp * 1000)
        let MyDateString =
          ('0' + (d.getMonth() + 1)).slice(-2) +
          '/' +
          ('0' + d.getDate()).slice(-2) +
          '/' +
          d.getFullYear()
        return MyDateString
      }
      return ''
    },
    adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      })
    },
    showMoreInfo(request) {
      console.log(request)
      let vm = this
      vm.$router.push({
        name: 'AdminRequestDetailPage',
        params: { id: request.id }
      })
      // this.getInvidualProvider({ npi: request.provider }).then(() => {
      //   const provider = this.provider
    },
    searchRequest() {
      if (
        this.searchFields.provider.firstName ||
        this.searchFields.provider.lastName
      ) {
        this.searchState++
        this.search({
          type: 'individual',
          terms:
            this.searchFields.provider.firstName +
            this.searchFields.provider.lastName
        }).then(results => {})
      }
      // TODO: Get a list of providers, same way as the patients

      if (
        this.searchFields.patient.firstName ||
        this.searchFields.patient.lastName
      ) {
        this.searchState++
        // Fetch list of patients to include in list of id on request search
        this.getPatients({
          firstName: this.searchFields.patient.firstName,
          lastName: this.searchFields.patient.lastName
        }).then(patients => {
          this.searchState--
          // Format array being sent to the request search
          let patientSearchArray = []
          for (const i in patients) {
            patientSearchArray.push(patients[i].id)
          }
          patientSearchArray = '["' + patientSearchArray.join('","') + '"]'
          this.patientSearchArray = patientSearchArray
        })
      }

      if (
        this.searchFields.patient.firstName === '' &&
        this.searchFields.patient.lastName === '' &&
        this.searchFields.provider.firstName === '' &&
        this.searchFields.provider.lastName === ''
      ) {
        this.getRequests({ limit: this.currentPagination.rowsPerPage })
      }
    }
  },
  computed: {
    ...mapState('admin', [
      'requests',
      'patient',
      'request',
      'requestsPageInfo',
      'patients',
      'loadingRequests'
    ]),
    ...mapState('provider', ['provider', 'providerAuthInfo']),
    activeRequests() {
      let onlyTheActive = []
      if (this.requests) {
        this.requests.forEach(element => {
          if (
            element.status !== 'CANCELLED' &&
            element.status !== 'COMPLETED'
          ) {
            onlyTheActive.push(element)
          }
        })
      }
      return onlyTheActive
    }
  },
  created() {
    this.getRequests({ limit: this.currentPagination.rowsPerPage })
  },
  watch: {
    request() {
      this.requests.find((r, i) => {
        if (r._id === this.request.id) {
          this.requests[i].status = this.request.status.status
          return true
        }
      })
    },
    searchState() {
      if (this.searchState === 0) {
        this.getRequests({
          limit: this.currentPagination.rowsPerPage,
          patients: this.patientSearchArray
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/form';

.centered {
  position: fixed;
  top: 35%;
  left: 50%;
}

.admin-title {
  font-size: 18px;
  font-weight: 400;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.admin-title-bold {
  font-size: 18px;
  font-weight: 600;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.search-field {
  background: #f5f5f5;
  border-radius: 4px;
  padding-left: 18px;
}

.table-border {
  border: 1px solid #f5f5f5;
}

.headerTabUnselected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  opacity: 0.2;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
.headerTabSelected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.headerTabUnselected:hover {
  opacity: 1;
}

.account-title {
  font-size: 24px;
  line-height: 30px;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/pages/admin/AdminRequestsPage.vue